let stickySidebar = {};

/**
 *  getOffset
 *  Get the current top/left coordinates of an element relative to the document.
 *
 *  @since 5.0
 *  @param {*} el
 */
stickySidebar.getOffset = function(el = null) {
	if (!el) {
		return false;
	}
	let rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
};

/**
 * @param {HTMLElement} target Stuck element
 * @param {HTMLElement} container The target element container
 * @param {Number} top The top position to stick
 */
stickySidebar.attachShare = function(target, container, top) {
	let height = target.offsetHeight;
	let width = document.querySelector('.sticky-sidebar--cta-wrap').offsetWidth;
	target.style.width = `${Math.round(width)}px`;
	let containerHeight = container.offsetHeight;
	let headerHeight = document.querySelector('.site-header').offsetHeight;

	let scrollTop = window.scrollY;
	let containerOffset = stickySidebar.getOffset(container);
	let bottom = containerOffset.top + containerHeight; // absolute bottom of element to hide sticky

	if (containerHeight > height && window.outerHeight > headerHeight) {
		// Container height larger than target

		if (scrollTop > containerOffset.top - top) {
			if (scrollTop + height + top > bottom) {
				target.classList.add('attached-bottom');
				target.style.position = 'absolute';
				target.style.top = 'auto';
				target.style.bottom = `0px`;
			} else {
				target.style.position = 'fixed';
				target.style.top = `${top}px`;
				target.style.bottom = 'auto';
			}
		} else {
			if (scrollTop <= containerOffset.top - top) {
				target.style.position = 'static';
			}
		}
	}
};

const stickyCta = document.querySelector('.sticky-sidebar');
const stickyTop = 40;
if (stickyCta) {
	let target = document.querySelector('.sticky-sidebar--cta');
	let container = document.querySelector('.sticky-sidebar');
	window.addEventListener('resize', function() {
		stickySidebar.attachShare(target, container, stickyTop);
	});
	window.addEventListener('scroll', function() {
		stickySidebar.attachShare(target, container, stickyTop);
	});
	stickySidebar.attachShare(target, container, stickyTop);
}
